module.exports = __webpack_public_path__ + "img/9788996328704.7fff0e13.jpg";